import { memo, FC } from 'react'
import dynamic from 'next/dynamic'
import { CardHeader } from '@app/components/stateless/card/header'
import { EmptyDialogButton } from '../empty-dialog'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import { WebsiteBuilder } from '@app/components/svgs/website-builder'
import { Paragraph } from '@app/components/stateless/typo/paragraph'
import { dialogBtnStyles } from './form-dialog-styles'

const FormDialog = dynamic(
  () => import('../form-dialog').then((mod) => mod.FormDialog),
  {
    ssr: false,
    loading: () => <EmptyDialogButton buttonStyles={dialogBtnStyles} />,
  }
)

interface EmptyWebsiteProps {
  emptyHeaderTitle?: string
  emptyHeaderSubTitle?: string
  hasWebsite?: boolean
  goToPayments?: boolean
  onlyLive?: boolean
  storageless?: boolean
}

const EmptyWebsiteFormComponent: FC<EmptyWebsiteProps> = ({
  emptyHeaderTitle = 'Empty',
  emptyHeaderSubTitle = 'Add your website below',
  onlyLive,
}) => {
  const { t } = useTranslation('dashboard-empty')

  return (
    <div
      className={
        'flex flex-col w-full place-items-center py-10 my-2 text-center'
      }
    >
      <CardHeader title={emptyHeaderTitle} subheader={emptyHeaderSubTitle} lg />
      <FormDialog buttonStyles={dialogBtnStyles} dialogDisabled={onlyLive} />

      <div className={'flex space-items-center space-x-10 pt-12 pb-4 px-4'}>
        <ul
          className={
            'list-none w-full text-left space-y-2 md:w-full lg:w-1/2 xl:pr-12'
          }
        >
          {[0, 1, 2].map((detail: number) => {
            return (
              <li key={detail}>
                <h3 className={'text-lg md:text-xl xl:text-2xl font-semibold'}>
                  {t(`empty-list.${detail}.title`)}
                </h3>
                <Paragraph>{t(`empty-list.${detail}.details`)}</Paragraph>
              </li>
            )
          })}
        </ul>
        <div className={'hidden md:block'}>
          <WebsiteBuilder height={280} width={360} className='h-auto' />
        </div>
      </div>
    </div>
  )
}

export const EmptyWebsiteForm = memo(EmptyWebsiteFormComponent)
